<template>
        <div class="container">
            <el-form ref="form" :inline-message='true' :model="form" :rules="rules"  label-width="100px">
                <el-form-item label="运费模板：">
                    <el-select size='mini' :disabled="isDisabled" clearable @clear='clearFreight' v-model="freight" style="width:120px" @change="get">
						<el-option v-for='(item,index) in freightList' :key='index' :value="item.freighttemplateid" :label='item.freighttemplatename'></el-option>
					</el-select>
                </el-form-item>
				<div v-if='freight!=="" && isShow'>
					<el-form-item label="起订金额：">
						{{form.sendamount}}元
					</el-form-item>
					<el-form-item label="配送方式：">
						<!-- <span v-if='form.deliveryWay === 1'>快递</span>
						<span v-else>快递、自提</span> -->
						<el-checkbox-group v-model="form.deliveryWay">
							<el-checkbox :label="0" name="deliveryWay" disabled>快递</el-checkbox>
							<el-checkbox :label="1" name="deliveryWay" disabled>自提</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<div>
						<div v-if='form.deliveryWay.length>1'>
							<div style="margin-left:10px">
								<div style="margin-left:10px;font-size:14px">自提设置：
									<el-checkbox disabled v-model="buyerselfpickflag">需要买家选择自提时间</el-checkbox>
								</div>
								<div style="margin-left:80px;margin-top:5px;margin-bottom:10px;color:#606266">
									勾选后，买家下单选择自提配送方式后，必须选择自提时间，卖家需要按预定时间备货，不勾选，将会提示买家尽快到指定地方自提
								</div>
								<div v-if="buyerselfpickflag">
									<div style="float:left;margin-left:10px;font-size:14px;height:40px;line-height:40px;">
										自提时间：
									</div>
									<div class="time-box" v-for="(item,index) in selfpickTimes" :key='index'>
										<el-time-picker
											disabled
											value-format='HH:mm'
											format='HH:mm'
											is-range
											:clearable='false'
											size='mini'
											style="width:200px;margin-right:20px"
											v-model="item.val"
											range-separator="至"
											start-placeholder="开始时间"
											end-placeholder="结束时间"
											placeholder="选择时间范围">
										</el-time-picker>
									</div>
								</div>

								<div v-if="buyerselfpickflag" style="margin-left:10px;font-size:14px;margin-top:10px">
									自提设置：
									<el-checkbox-group
										v-model="week"
										style="display: inline-block;">
										<el-checkbox :label="1" disabled>星期一</el-checkbox>
										<el-checkbox :label="2" disabled>星期二</el-checkbox>
										<el-checkbox :label="3" disabled>星期三</el-checkbox>
										<el-checkbox :label="4" disabled>星期四</el-checkbox>
										<el-checkbox :label="5" disabled>星期五</el-checkbox>
										<el-checkbox :label="6" disabled>星期六</el-checkbox>
										<el-checkbox :label="7" disabled>星期日</el-checkbox>
									</el-checkbox-group>
								</div>
								<div v-if="buyerselfpickflag" style="margin-left:10px;font-size:14px;margin-top:10px">
									是否支持下单当天自提：
									<el-select size='mini' disabled v-model="samedayflag" style="width:120px">
										<el-option :value="false" label='不支持'></el-option>
										<el-option :value="true" label='支持'></el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>
					<div class="fx-title" v-if="form.deliveryWay.length>1">
						<span>设置自提地址</span>
					</div>
					<el-form-item v-if="form.deliveryWay.length>1" label="自提地址：" prop='address'>
						<el-input  :disabled="isDisabled" size='mini' style="width:200px" v-model="form.address"></el-input>
					</el-form-item>
					<el-form-item v-if="form.deliveryWay.length>1" label="联系电话：" prop='tel'>
						<el-input  :disabled="isDisabled" size='mini' type='number' style="width:200px" v-model="form.tel"></el-input>
					</el-form-item>
				</div>
				<div class="btn-box"  v-if="!isDisabled">
					<el-button size='mini' class="fx-big-btn" plain @click="cancel('form')">取消</el-button>
					<el-button size='mini' class="fx-big-btn" plain type="primary" @click="submitForm('form')">保存</el-button>
				</div>
            </el-form>
        </div>
</template>

<script>
export default {
	name: 'edit',
	data () {
		var phone = (rule, value, callback) => {
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		return {
			isShow: false,
			AuthorityList: {
				'01_0001_0001_00': true,
				'01_0001_0002_00': true,
				'01_0001_0003_00': true,
				'01_0001_0004_00': true,
				'01_0001_0005_00': true,
				'01_0001_0006_00': true,
				'01_0001_0007_00': true,
				'01_0001_0008_00': true
			},
			isDisabled: true,
			samedayflag: false,
			totalCount: 0,
			targettype: 1,
			week: [],
			freight: '',
			freightList: [],
			selfpickTimes: [],
			buyerselfpickflag: false,
			id: '',
			form: {
				address: '',
				tel: '',
				deliveryWay: [0],
				sendamount: 0,
				name: '',
				templatetype: 0,
				freighttype: 0
			},
			rules: {
				address: [
					{ required: true, message: '请输入自提地址', trigger: 'blur' }
				],
				tel: [
					{ required: true, validator: phone, trigger: 'blur' }
				]
			}
		}
	},
	created () {
		this.getAuthority('01_0001_0000_00')
		this.getFreightList()
		this.getDetial()
	},
	methods: {
		clearFreight () {
			this.freight = ''
			this.form.address = ''
			this.form.tel = ''
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('isAdd')
					if (add === 'true') {
						if (this.AuthorityList['01_0001_0002_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['01_0001_0001_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		cancel (formName) {
			this.freight = null
			this.isShow = false
			this.$refs[formName].resetFields()
			this.getFreightList()
			this.getDetial()
		},
		getDetial () {
			let params = {
				id: sessionStorage.getItem('storeid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freighttemplate/extra`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data !== null) {
						this.form.tel = res.data.tel
						this.form.address = res.data.address
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		submitForm (formName) {
			if (this.freight === '') {
				let params = {
					id: sessionStorage.getItem('storeid')
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/freighttemplate/save`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('保存成功')
					} else {
						this.$message.error(res.msg)
					}
				})
			} else {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {
							id: sessionStorage.getItem('storeid'),
							freightTemplateid: this.freight,
							address: this.form.address,
							tel: this.form.tel
						}
						this.$store.dispatch('requestPost', {
							url: `${this.$fxBaseApi.urlQIV}/shop/freighttemplate/save`,
							data: params
						}).then(res => {
							if (res.result) {
								this.$message.success('保存成功')
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				})
			}
		},
		getFreightList () {
			let params = {
				id: sessionStorage.getItem('storeid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freighttemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.freightList = res.data
					if (res.data.length > 0) {
						if (res.data[0].bindflag === 1) {
							this.freight = res.data[0].freighttemplateid
							this.$nextTick(() => {
								this.get()
							})
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		get () {
			let params = {
				id: this.freight
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.isShow = true
					// selfpickflag =1 开启自提
					if (res.data.detail.selfpickflag === 0) {
						this.form.deliveryWay = [0]
					} else {
						this.sftid = res.data.selfpickData.id
						this.form.deliveryWay = [0, 1]
						this.buyerselfpickflag = res.data.selfpickData.buyerselfpickflag
						if (this.buyerselfpickflag) {
							this.samedayflag = res.data.selfpickData.samedayflag
							this.week = res.data.selfpickData.week
							let list = res.data.selfpickData.selfpickTimes
							let arr = []
							for (let i = 0; i < list.length; i++) {
								let a = {
									val: [list[i].startdate, list[i].enddate]
								}
								arr.push(a)
							}
							this.selfpickTimes = arr
						}
					}
					this.id = res.data.detail.id
					this.form.sendamount = this.$fxUtils.toFixedSHW(res.data.detail.sendamount, 2)
					this.areaTableData = res.data.areaList
					this.form.templatetype = res.data.detail.templatetype
					this.form.freighttype = res.data.detail.freighttype
					this.form.name = res.data.detail.name
					this.targettype = res.data.targettype
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		dialogClose () {
			this.showTree = false
			this.addTree = false
		},
		editTree (id) {
			this.treeId = id
			this.showTree = true
			this.addTree = false
		},
		addClick () {
			this.treeId = '0'
			this.showTree = true
			this.addTree = true
		},
		goBack () {
			this.$router.push('/main/freight')
		}
	}
}
</script>

<style  lang="stylus" scoped>
.container{
	padding-top :10px;
    overflow :auto;
    text-align :left;
    box-sizing :border-box;
    width :100%;
    .input-box{
        width:200px;
    }
	.btn-box{
        margin 10px
    }
    .table-box{
        margin-left: 10px;
        margin-top :10px;
        height :150px;
        .grid-content{
            box-sizing :border-box;
            height :100%;
            overflow-y :auto
        }
        .cell-input{
            width :100px
        }
    }
    .time-box{
        width:300px;
        height :40px;
        line-height :40px;
        margin-left:80px;
        .time-btn{
            padding:5px !important
        }
    }
}

</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
</style>
